import { http, ep } from '../../client/http';

export const aboutRepo = {
  get: async () => {
    const res = await http.get(ep('about'));
    return res.data.data;
  }
};
